define((require) => {
    "use strict";

    const {isFunction}  = require("underscore");
    const Preconditions = require("shared/util/Preconditions");
    const {Logger}        = require("shared/util/Logger");

    const log = new Logger("Adapter Util");

    /**
     * Generic data adapter will be used to external communication with system like SalesforceCommerce or
     * other integrations.
     *
     * @class AdapterUtil
     * @constructor
     */
    return {

        _source: null,

        /**
         * Set the map property.<p>
         * @example
         * <pre>
         *  {
         *    name: {
         *     defaultValue: "No name",        // "No name" defaultValue in case of the use don't pass a value; optional
         *     type: "string",                 // type of the object, if is passed the value will be checked; optional
         *     value: "name"                   // Value field of the object.
         *    },
         *    minAge: {
         *      type: "number",
         *      value:  function(){
         *        return  this.age > 18 ? 25 : 13;
         *      }
         *    }
         *  }
         * </pre>
         * @returns {AdapterUtil} returns the chain object
         */
        map(map) {
            Preconditions.checkArgument(map);

            this._map = map;

            return this;
        },

        /**
         * @private
         * Map object.
         */
        _map: null,

        /**
         * Transform the source in a new object.
         *
         * @param {Object} source that will be the object transformed.
         * @returns {Object}
         */
        transform(source) {
            const target = {};
            let attrProperties;
            let value;

            this._source = source;

            // Run each property of the map.
            for (const propertyName in this._map) {
                // Take the description of the field like "name" or age"
                attrProperties = this._map[propertyName];

                value = this._getProp(attrProperties, "value") || this._getProp(attrProperties, "defaultValue");

                this._setNewProp(attrProperties, target, propertyName, value);
            }

            return target;
        },

        /**
         * Set a property in the newObject, it may validate the type of the object
         * in case of the type is present inside of meta.
         *
         * @param {Object} meta properties of the item.
         * @param {Object} newObject newObject being created in execution time.
         * @param {String} propName PropertyName of the object.
         * @param {Object} propValue PropertyValue of the object.
         * @private
         */
        _setNewProp(meta, newObject, propName, propValue) {
            // eslint-disable-next-line dot-notation, valid-typeof
            if (meta["type"] && typeof propValue !== meta["type"]) {
                const errorMsg = "The type is different of the informed for the map.";

                log.error(errorMsg);
            }

            newObject[propName] = propValue;
        },

        _getProp(attrProperties, propertyKey) {
            let output = null;

            try {
                const prop = attrProperties[propertyKey];

                if (isFunction(prop)) {
                    output = prop.call(this._source);
                } else {
                    /* eslint-disable no-lonely-if */
                    if (propertyKey !== "value") {
                        // Get the prop through a function or itself.
                        output = prop;
                    } else {
                        // Get the prop through a function or an associated field.
                        output = this._source[prop];
                    }
                }
            } catch (e) {
                log.error("Error trying to map an attribute ", propertyKey, attrProperties, e);
            }

            return output;
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/AdapterUtil.js